import React from 'react';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ViewDocx from '../components/ViewDocx'
import ReviewFile from '../components/ReviewFile'
import ReviewDocument from '../components/ReviewDocument'
import ReviewDocumentLogs from '../components/ReviewDocumentLogs'
import ReviewFileLogs from '../components/ReviewFileLogs'
import { useState, useEffect} from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PhoneIcon from '@mui/icons-material/Phone';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PreviewIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HistoryIcon from '@mui/icons-material/History';
import GradingIcon from '@mui/icons-material/Check';
import {HOST} from './config';
import PreviewDocJSON from '../components/PreviewDocJSON';
import CaseDocFilePreviewer from '../components/CaseDocFilePreviewer';

function CaseDocPreviewPane(props) {
  const previewUrl = props.previewUrl
  const previewType = props.previewType
  const stylePreviewer = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };


  const files = props.files
  const [currentIndex, setCurrentIndex] = useState(-1)
  const [uriToLoad, setUriToLoad] = useState(null);
  //const [currentFile, setCurrentFile] = useState({})
  const [currentTypeOverride, setCurrentTypeOverride] = useState(null)
  const [zoomLevel, setZoomLevel] = useState(1) 
  const [currentTab, setCurrentTab] = useState('preview') 
  const [currentFileInfo, setCurrentFileInfo] = useState({}) 
 
  const currentId = currentFileInfo.id

  //const [isGenerating, setIsGenerating] = useState(false) 
 
  const isGenerating = props.currentFile.info.generated_status == 'GENERATING' 

  const resetDefaults = () => {
    setUriToLoad(null)
    setCurrentTypeOverride(null)
    setCurrentTab('preview')
    setCurrentFileInfo({})
    setCurrentIndex(-1)
  }

  console.log(currentFileInfo)

  useEffect(() => {
    if (props.caseId)
      resetDefaults()
  }, [props.caseId])
  
  
  const reloadCurrentDocInfo = async () => {
    if (props.currentFile.type == 'case_doc') {
      console.log("reload called")
      console.log(isGenerating)
      props.reloadCaseDocumentInfo()
    }  
  }
 
  const needsRegenFromInfo = (info) => {
    if (!info.generate_filetype)
      return false
    if (!info.generated_at)
      return true
    const lastUpdatedAt = info.inputs_updated_at || info.created_at
    return info.generated_at < lastUpdatedAt
  }

  useEffect( () => {
    const needsRegeneration = needsRegenFromInfo(props.currentFile.info)
    if (currentTab == 'preview' && needsRegeneration) {
       handleCaseDocGenerate(props.currentFile.documentId) 
    }
  }, [props.currentFile.documentId, props.currentFile.type, currentTab]);
  

  const handleCaseDocGenerate = async (assembly_case_document_id) => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assembly_case_document_id+'/generate/', { 
          "method": "POST",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        props.setCurrentFile({...props.currentFile, info: {...props.currentFile.info, generated_status: "GENERATING" }}) 
      } catch (err) {
      }   
  };
 
  const handleDownload = () => {
    if (props.currentFile.type == 'case_doc')
      window.open(props.currentFile.downloadUrl, '__blank');
    else
      window.open(uriToLoad, '__blank');
  }
  
  const handleDocumentDelete = async (document_id) => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + document_id +'/', { 
          "method": "DELETE",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          },  
          });
        props.fetchDocs()
        setCurrentIndex(currentIndex + 1) 
      } catch (err) {
      }   
    };


  useEffect( () => {
    if (props.previewDocumentId != null) {
      const matchingIndex = files.findIndex((file) => file.documentId == props.previewDocumentId)
      setCurrentIndex(matchingIndex)
    }
  }, [props.previewDocumentId])
  
  useEffect( () => {
    if (props.previewFileId != null) {
      const matchingIndex = files.findIndex((file) => file.fileId == props.previewFileId)
      setCurrentIndex(matchingIndex)
    }
  }, [props.previewFileId])


  useEffect(() => { 
      reloadCurrentDocInfo() 
    }, [props.currentFile.documentId])
  
  useEffect(() => { 
      if (props.currentFile.type == 'client_file')
        setUriToLoad(props.currentFile.download_url)
      else if (props.currentFile.type == 'case_doc') {
        setUriToLoad(props.currentFile.download_url)
        ;
      }
    }, [props.currentFile])

    useEffect(() => {
      const intervalId = setInterval(() => { 
        if (props.currentFile.type == 'case_doc')
          if (isGenerating)
            props.reloadCaseDocumentInfo()
        
        }, 5000); // Poll every 5 seconds
      
      return () => {
        clearInterval(intervalId); // Clear interval on unmount
      };
    }, [isGenerating, props.currentFile])

    const currentType = currentTypeOverride != null ? currentTypeOverride : props.currentFile.fileType 
  
    if (!props.previewDocumentId && !props.previewFileId)
      return (<></>)
 
    return (
    <Paper sx={{p: 0  }} elevation={2} >
      <Box display='flex' sx={{ height: 'calc(100vh - 70px)', flexDirection: "column" }}>
      <Box className='' sx={{ p: 2, mt: 3, width: '100%%',  flexGrow: 0, marginTop: "" }} > 
        <Grid container >
          <Grid item xs={12}>
            <Typography variant='h6' sx={{ m: 0 }}>{props.currentFile.filename}</Typography>
              <Stack direction="row" spacing={1}>
                <Chip size='small' color='primary' label={props.currentFile.type == 'client_file' ? 'Client File' : 'Prepared Document' }
 />
                <span className='mt-1 pt-1'>{new Date(props.currentFile.created_at).toLocaleString()}</span>
              </Stack>
                { props.currentFile.type == 'case_doc' && props.filesAreProcessing && 
                  <Alert sx={{mt: 1}} severity="warning">{"Relevant files are still being processed."}</Alert>
                }
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Box className='' sx={{ p: 0, mt: 0, width: '100%%',  flexGrow: 0, marginTop: "" }} > 
        <Tabs variant='fullWidth' value={currentTab} onChange={(event, newValue) => {
            setCurrentTab(newValue);
          }} aria-label="icon label tabs example">
          <Tab icon={<PreviewIcon />} value='preview' label="PREVIEW" />
          <Tab icon={<GradingIcon />} value='review' label="EDIT" />
          <Tab icon={<HistoryIcon />} value='logs' label="LOGS" />
        </Tabs>
      </Box>
      <Divider />

      
      { currentTab == 'logs' &&
        <Box className='pt-3' sx={{ ml: 0, mr: 0, width: '100%%', height: '75%', marginTop: "" }} > 
            <>
              { props.currentFile.type == 'client_file' &&
                <ReviewFileLogs 
                  info={props.currentFile.info}   
                /> 
              }
              { props.currentFile.type == 'case_doc' &&
                <ReviewDocumentLogs
                  setPreviewDocumentId={props.setPreviewDocumentId}
                  handleDelete={() => handleDocumentDelete(props.currentFile.documentId)}
                  info={props.currentFile.info}
                />
              }
            </>
        </Box>
      }
      { currentTab == 'preview' &&
        <Box className='pt-3' sx={{ ml: 0, mr: 0, width: '100%%', height: '75%', marginTop: "" }} > 
            <>
              { currentType == 'pdf' &&
                <Typography align='left' sx={{ p: 2 }} style={{"position": 'absolute', display: "fixed", zIndex: 10 }} >
                  <IconButton onClick={handleDownload}><DownloadIcon /></IconButton>
                  <IconButton onClick={() => setZoomLevel(zoomLevel*0.75)}><ZoomOutIcon /></IconButton>
                  <IconButton onClick={() => setZoomLevel(zoomLevel*1.25)}><ZoomInIcon /></IconButton>
                </Typography>
              }
              
              { props.currentFile.type == 'case_doc' &&
                <CaseDocFilePreviewer 
                  isGenerating={isGenerating}
                  handleRegenerate={() => handleCaseDocGenerate(props.currentFile.documentId)}
                  handleDownload={handleDownload}
                  fileInfo={currentFileInfo}
                  currentType={currentType}
                  zoomLevel={zoomLevel}
                  generatedStatus={props.currentFile.info.generated_status}
                  uriToLoad={props.currentFile.downloadUrl}
                />
              }
              { props.currentFile.type == 'client_file' &&
                <>
                  { (currentType == 'pdf' || currentType == 'docx') && 
                    <ViewDocx fileType={currentType} zoomLevel={zoomLevel} uri={uriToLoad} />
                  }
                </>
              }
              { (currentType == null || currentType == 'json') &&
                <PreviewDocJSON assemblyCaseDocumentId={props.currentFile.documentId} />
              }
            </>
          
        </Box>
      }
      { currentFileInfo && currentTab == 'review' &&
        <>
          { props.currentFile.type == 'client_file' &&
            <ReviewFile 
              info={props.currentFile.info}   
            /> 
          }
          { props.currentFile.type == 'case_doc' &&
            <ReviewDocument
              isGenerating={isGenerating}
              setPreviewDocumentId={props.setCurrentFile}
              reloadInfo={() => reloadCurrentDocInfo() }
              info={props.currentFile.info}
            />
          }
        </>
      }
    </Box>
    </Paper>
  )
}
export default CaseDocPreviewPane;
